<!---分享红包-->
<template>
  <layer
    name="ActivityRedPacket"
    mask-direction="Middle"
    style="z-index: 101"
    :visible="visible"
  >
    <div class="dlrLayer-middle utilMod-puCarve">
      <div class="utilMod-puCarve-wrap">
        <p class="utilMod-puCarve-name">瓜分购车红包</p>
        <p class="utilMod-puCarve-text">
          ￥
          <ins>{{ redpacket.value }}</ins>
        </p>
        <p class="utilMod-puCarve-btn" @click="pickRedPacket">马上领取</p>
      </div>
      <span
        class="utilMod-puCarve-close"
        data-mask-close="Layer02"
        data-mask-direction="middle"
        @click="close"
      ></span>
    </div>
    <div
      class="dlrLayer-mask"
      data-mask-close="Layer02"
      data-mask-direction="middle"
      @click="close"
    ></div>
  </layer>
</template>
<script>
import { mapGetters } from 'vuex';
import Layer from './Layer.vue';
import RedPacketService from '../services/redPacket.service';
import util from '../utils/util';
export default {
  name: 'ActivityRedPacket',
  props: {
    options: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  components: {
    Layer
  },
  computed: {
    ...mapGetters({
      baseInfo: 'baseInfo'
    }),
    dealerId () {
      return this.baseInfo.dealerId;
    }
  },
  data () {
    return {
      visible: true,
      redpacket: {},
      redpacketService: null
    };
  },
  created () {
    this.redpacketService = new RedPacketService(this.baseInfo);
    this.show(this.options);
  },
  methods: {
    show (options) {
      console.log(options);
      const self = this;
      self.redpacket = options;
      function setRedPacketCookie (dealerId) {
        util.setCookie({
          name: 'hideRedPacketTwoHours_' + dealerId,
          value: 'true',
          time: 2 * 60 * 60 * 1000
        });
      }
      setRedPacketCookie(self.dealerId);
    },
    close () {
      this.visible = false;
    },
    pickRedPacket () {
      const self = this;
      const redpacketData = [self.redpacket];
      const redpacketUrl = self.redpacketService.buildRedPacketUrl(redpacketData);
      const jumpUrl = redpacketUrl.split('|')[0];
      window.location.href = jumpUrl;
    }
  }
};
</script>
<style lang="scss">

.utilMod-puCarve {
  margin: ptrd(-100) 0 0 0;
  &-wrap {
    position: relative;
    width: ptrd(594);
    height: ptrd(700);
    padding: ptrd(116) ptrd(40) ptrd(40) ptrd(40);
    background: url(https://s.autoimg.cn/dealer/m/utility_modules/img/ls_pu_luck.png)
      no-repeat ptrd(-8) ptrd(-746);
    background-size: ptrd(594);
    box-sizing: border-box;
  }
  &-name {
    height: ptrd(80);
    line-height: ptrd(80);
    text-align: center;
    font-size: ptrd(60);
    font-weight: bold;
    text-shadow: 0 0 10px #d60007;
    color: #ffe6b7;
    @extend %ellipsis-basic;
  }

  &-text {
    margin-top: ptrd(10);
    height: ptrd(150);
    line-height: ptrd(150);
    text-align: center;
    font-size: ptrd(66);
    font-weight: bold;
    text-shadow: 0 0 10px #d60007;
    color: #ffe6b7;
    @extend %ellipsis-basic;

    ins {
      text-decoration: none;
      font-size: ptrd(140);
      @extend %font-number;
    }
  }

  &-btn {
    width: ptrd(480);
    height: ptrd(135);
    line-height: ptrd(134);
    margin: ptrd(166) auto 0 auto;
    background: url(https://s.autoimg.cn/dealer/m/utility_modules/img/ls_pu_luck.png)
      no-repeat ptrd(-20) ptrd(-2294);
    background-size: ptrd(594);
    font-size: ptrd(34);
    color: #a21112;
    text-align: center;
    font-weight: bold;
  }
  &-close {
		position: absolute;
		bottom: ptrd(-194);
		left: calc(50% - #{ptrd(38)});
		width: ptrd(76);
		height: ptrd(76);
		background: url("data:image/png;base64,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") no-repeat center center;
		background-size: ptrd(76);
	}
}
</style>
